﻿export default class PatGlobalUpdate {

    controllerUrl = "";
    refreshLog = true;

    caseNumberSearchValueMapper(options) {
        const url = $("#updateCriteriaForm").data("case-number-mapper-url");
        $.ajax({
            url: url,
            data: { value: options.value },
            success: function (data) {
                options.success(data);
            }
        });
    }

    getCriteria() {
        const form = $("#updateCriteriaForm");
        const data = pageHelper.formDataToJson(form, false);

        const updateField = $("#UpdateField_patGlobalUpdate").data('kendoComboBox').value();
        const dataFrom = $("#FromData_patGlobalUpdate").data('kendoComboBox').value();
        const dataTo = $("#ToData_patGlobalUpdate").data('kendoComboBox').value();
        data.payLoad["UpdateField"] = updateField;
        data.payLoad["DataFrom"] = dataFrom;
        data.payLoad["DataTo"] = dataTo;

        const multiselect = $("#ApplicationStatuses").data("kendoMultiSelect");
        const items = multiselect.value();
        let appStatuses = "";        

        for (var i = 0; i < items.length; i++) {
            appStatuses += "|" + items[i] + "|";
        }

        data.payLoad["ApplicationStatuses"] = appStatuses;

        return data.payLoad;
    }

    getUpdateField() {
        return $("#UpdateField_patGlobalUpdate").data('kendoComboBox').value();
    }

    getUpdateFieldFromParam = () => {
        var fromDataVal = $("#FromData_patGlobalUpdate").data('kendoComboBox').text();
        return { updateField: this.getUpdateField(), fieldValue: fromDataVal };
    }

    getUpdateFieldToParam = () => {
        var toDataVal = $("#ToData_patGlobalUpdate").data('kendoComboBox').text();
        return { updateField: this.getUpdateField(), fieldValue: toDataVal };
    }

    configurePreviewRows=()=> {
        const updateField = this.getUpdateField();
        let isCtryAppLevel = false;
        let isActionLevel = false;
        if (updateField === "RespAtty") isActionLevel = true;
        if ("Agent-AppOwner-ApplicationStatus-AppInventor".search(updateField) > -1) isCtryAppLevel = true;

        if (isActionLevel) {
            $(".updateActionBlock").show();
        } else {
            $(".updateActionBlock").hide();
        }
        if (isCtryAppLevel || isActionLevel) {
            $(".updateCtryAppBlock").show();
        } else {
            $(".updateCtryAppBlock").hide();
        }
    }

    refreshUpdatePreview = function () {

        // if no update field and data from, 
        if ($("#UpdateField_patGlobalUpdate").data('kendoComboBox').value() === "" ||
            $("#FromData_patGlobalUpdate").data('kendoComboBox').value() === "") {
            $('#previewListView').data('kendoListView').dataSource.data([]);
            return;
        }
        const listView = $('#previewListView').data('kendoListView');
        listView.dataSource.read();
        listView.dataSource.page(1);
    }

    // no need to trap this event, the fromDataChange kicks off before this (and takes care of the refresh)
    //this.updateFieldChange = function (e) {
    //    alert("updateFieldChange");
    //    $('#previewListView').data('kendoListView').dataSource.data([]);
    //}

    fromDataChange = (e)=> {
        const tab = $('.tab-header .active').attr('id');
        if (tab === "Records-tab") {
            this.refreshUpdatePreview();
        }
    }

    bindEvents = () => {
        // tab change
        $('#update-tab a').on('click', (e)=> {
            const tab = e.target.id;
            switch (tab) {
                case "Records-tab":
                    this.refreshUpdatePreview();
                    break;
                case "Log-tab":
                    if (this.refreshLog) {
                        const logGrid = $('#updateLog').data('kendoGrid');
                        logGrid.dataSource.read();                        
                        this.refreshLog = false;
                    }
                    break;
            }
        });

        $("#UpdateField_patGlobalUpdate").change((e)=> {
            const chkComboFields = "CaseNumber-FamilyNumber-Agent-Attorney1-Attorney2-Attorney3-Client-InvOwner-AppOwner";
            const updateField = $("#UpdateField_patGlobalUpdate").data('kendoComboBox').value();
            let prevDisabledElt = $("#prevDisabledElt").val();               // use for disabling criteria fields (disable if = data to update)
            const screen = "patGlobalUpdate";

            //alert(prevDisabledElt);
            //alert(updateField);

            if (prevDisabledElt !== "") {
                // enable previously disable combo box
                if (chkComboFields.search(prevDisabledElt) > -1) {
                    enableComboBox(`#${prevDisabledElt}_${screen}`, true);
                    enableComboBox(`#${prevDisabledElt}Name_${screen}`, true);
                }
                else if (prevDisabledElt === "ApplicationStatus") {
                    enableAppStatus(true);
                }
                // clear
                prevDisabledElt = "";
            }

            // check if we need to disable criteria field = updatefield
            if (chkComboFields.search(updateField) > -1) {
                prevDisabledElt = updateField;
                enableComboBox(`#${prevDisabledElt}_${screen}`, false);
                enableComboBox(`#${prevDisabledElt}Name_${screen}`, false);
            }
            else if (updateField === "ApplicationStatus") {
                enableAppStatus(false);
                prevDisabledElt = updateField;
            }

            $("#prevDisabledElt").val(prevDisabledElt);

            function enableComboBox(comboName, enable) {
                const comboBox = $(comboName).data("kendoComboBox");
                comboBox.enable(enable);
            }

            function enableAppStatus(enable) {
                const multiSelect = $("#ApplicationStatuses").data("kendoMultiSelect");
                multiSelect.enable(enable);
                $('input[name=ActiveSwitch]').attr("disabled", !enable);
            }
        });



        $("#runUpdate").on('click', (e)=> {
            // require from data
            if ($("#FromData_patGlobalUpdate").data('kendoComboBox').value() === "") {
                alert('Please enter the data you want to update.');
                return;
            }

            // don't allow if update sets appstatus or inventors to null
            const updateField = this.getUpdateField();
            if ($("#ToData_patGlobalUpdate").data('kendoComboBox').value() === "" &&
                ("ApplicationStatus-InvInventor-AppInventor".search(updateField) > -1)) {
                alert(`You cannot remove: ${updateField}`);
                return;
            }

            if (!confirm("This action will update the records using the criteria you entered.\nAre you sure you want to do this?"))
                return;

            const param = this.getCriteria();
            $.ajax({
                url: this.controllerUrl + "PatGlobalUpdate/RunUpdate",
                data: param,
                success: (data)=> {
                    alert("Records updated: " + data);
                    this.refreshLog = true;
                    this.refreshUpdatePreview();
                },
                error: function (e) {
                    if (e.responseJSON !== undefined)
                        pageHelper.showGridErrors(e.responseJSON);
                    else
                        pageHelper.showErrors(e.responseText);
                }
            });
        });

    }

    updateLogDataBound = (e) => {
        const data = e.sender.dataSource.data();        

        if (data.length > 0) {
            const listView = e.sender.element;

            //Weird issue with rendering page on different browsers/computers
            //Set delay to ensure the tag exists before run textOverflow()
            setTimeout(
                function () {    
                    //collapsible container
                    $.each(listView.find(".globalUpdate-collapsible"), function () {
                        $(this).textOverflow();
                    });
                }, 150);                        
        }
    }
}


